export default {
  light: {
    primary: '#46d173',
    secondary: '#447fff',
    accent: '#7d31f8',
    error: '#ff7666',
    info: '#808080',
    success: '#46a21d',
    warning: '#ff7666'
  },
  dark: {
    primary: '#46d173',
    secondary: '#447fff',
    accent: '#7d31f8',
    error: '#ff7666',
    info: '#808080',
    success: '#46a21d',
    warning: '#ff7666'
  }
}
